import React from 'react'
import { I18n } from 'react-redux-i18n'
import { formatCurrency } from '../lib/currency-formatter'

import { Trade, Price, TradeCommandType } from '@bdswiss/mt4-connector'

export interface Props {
  position: Trade
  currency: string
  locale: string
  asset?: Price
  onShowChart: (symbol: string, tradeType: TradeCommandType) => void
}

const PositionClosed = ({ position, currency, locale, asset, onShowChart }: Props) => {
  // const precision = asset ? asset.digits : 5;
  return (
    <div className="ClosedPositionDetails d-flex flex-row justify-content-start">
      <div className="pad-20">
        <span className="inline-label">{I18n.t('invested')}: </span>{' '}
        {position.investment
          ? formatCurrency(position.investment!, currency, locale)
          : `${position.volume} ${I18n.t('lots', { count: position.volume === 1 ? 1 : 0 })}`}
      </div>
      {position.leverage ? (
        <div className="pad-20">
          <span className="inline-label">{I18n.t('leverage')}: </span> x{position.leverage}
        </div>
      ) : (
        undefined
      )}
      {'commission' in position ? (
        <div className="pad-20">
          <span className="inline-label">{I18n.t('commission')}: </span>{' '}
          {formatCurrency(position.commission!, currency, locale, currency === 'CUD' ? {precision: 2} : {})}
        </div>
      ) : (
        undefined
      )}
      {'swaps' in position ? (
        <div className="pad-20">
          <span className="inline-label">{I18n.t('swaps')}: </span>{' '}
          {formatCurrency(position.swaps!, currency, locale)}
        </div>
      ) : (
        undefined
      )}
    </div>
  )
}

export default PositionClosed
